import colors from './colors'

export default {
  title: 'Site settings',

  titles: {
    settings: 'Site settings',
    reseller: 'Site settings for reseller',
    resellers: 'Resellers',
    auth: 'Authorization',
    frontend: 'Frontend',
    notifications: 'Notifications',
    payments: 'Payments',
    globalBlacklistManager: 'Global Blacklist',
    apisender: 'API Sender',
    integrations: 'Integrations',
    misc: 'Miscellaneous',
    'otp-verification': 'OTP verification'
  },

  subtitles: {
    globalBlacklistManager: 'List settings',

    resellers: {
      domains: 'Domains'
    },

    auth: {
      registration: {
        defaults: 'Registration defaults'
      }
    },

    frontend: {
      title: 'Site title',
      colors: 'Site colors',
      documents: 'Public documents',
      jivosite: 'Jivosite settings'
    },

    payments: {
      methods: 'Payment method settings'
    },

    apisender: {
      settings: {
        readChatSettings: 'Read chat settings',
        sendMessageSettings: 'Send message settings',
        webhookSettings: 'Webhook settings'
      }
    },

    integrations: {
      yclients: {
        applicationCredentials: 'Application credentials'
      }
    },

    notifications: {
      sms: 'SMS notifications',
      extraRecipients: 'Additional notification recipients',

      email: {
        smtp: 'SMTP connection'
      },

      templates: {
        users: 'Templates for users',
        managers: 'Templates for managers'
      },

      events: {
        providers: {
          health: {
            recipients: 'Recipients of provider status notifications'
          }
        }
      }
    },

    misc: {
      rootId: 'Root ID'
    },

    'otp-verification': {
      'user-phone': 'Widget settings'
    }
  },

  labels: {
    reseller: 'Choose reseller',

    resellers: {
      domains: {
        domain: 'Domain',
        user: 'User'
      }
    },

    auth: {
      registration: {
        defaults: {
          allowDuplicates: 'Allow duplicates',
          sendernamesCheck: 'Restrict sender names for selected types',
          patternsCheck: 'Mandatory moderation pattern check for selected types',
          balance: 'Default balance',
          tariffs: 'Default tariff',
          routingGroups: 'Default routing groups',
          messageRuleGroups: 'Default message rule groups',
          sendernames: 'Sender names',
          patterns: 'Patterns',
          currency: 'Currency'
        }
      }
    },

    frontend: {
      title: 'Site title',
      colors: colors.labels,
      jivosite: 'Jivosite ID',

      documents: {
        privacyPolicy: 'Privacy Policy',
        publicOffer: 'Public Offer'
      }
    },

    payments: {
      allowedGlobalMethods: 'Allowed global payment methods'
    },

    globalBlacklistManager: {
      mainListId: 'Main List',
      temporaryAvailableListId: 'Temporary Available List'
    },

    integrations: {
      yclients: {
        applicationCredentials: {
          id: 'Application ID',
          token: 'Application token'
        }
      }
    },

    notifications: {
      extraRecipients: 'Recipients',

      sms: {
        senderUserId: 'Sender',
        sendername: 'Sender name'
      },

      email: {
        smtp: {
          host: 'Host',
          port: 'Port',
          from: 'From',
          login: 'Login',
          password: 'Password'
        }
      },

      events: {
        providers: {
          health: {
            recipients: 'Recipients'
          }
        }
      }
    },

    misc: {
      rootId: 'UUID'
    },

    'otp-verification': {
      'user-phone': {
        widgetId: 'Widget',
        widgetToken: 'Token'
      }
    }
  },

  hints: {
    warning: 'You are editing the site settings of the selected user.',

    frontend: {
      colors: colors.hints,
      jivosite: 'Enter your personal Jivosite ID to enable embedded support chat',

      documents: {
        privacyPolicy: 'File that will be available for end users to read',
        publicOffer: 'File that will be available for end users to read'
      }
    },

    notifications: {
      extraRecipients: 'Notifications on the balance status of all users of the system',

      events: {
        balance: {
          limit: {
            title: 'Notification will be sent when balance will reach {amount}',
            onLimit: 'When balance is',
            noLimit: '<not specified>',
            notifyBy: 'notify via',
            noNotifications: '<no method selected>',
            activator: 'We will send you notification when your balance will reach {limit}',
            overdraft: ' + user overdraft',
            invoice: 'Attach invoice for the amount {amount}'
          }
        }
      },

      email: {
        templates: {
          balance: {
            limit: 'Message that will be sent when one of balance limits is reached'
          },

          auth: {
            registration: 'Message that will be sent when user registered',
            recover: 'Message that will be sent to the user when trying to recover the password'
          },

          manager: {
            balance: {
              limit:
                'Message that will be sent to manager and administrator when one of user\'s balance limits is reached'
            },

            providers: {
              health: 'Message that will be sent to manager when provider disconnects for some reason'
            }
          }
        }
      },

      sms: {
        templates: {
          otp: {
            generate: {
              sendernames: {
                moderation: 'A message will be sent upon SMS confirmation of the senders number'
              }
            }
          }
        }
      }
    },

    payments: {
      methods: 'Setup different payment methods using predefined payment system integrations'
    }
  },

  misc: {
    globalSettings: 'Global settings'
  },

  snackbars: {
    updated: 'Setting successfully updated.'
  },

  patterns: {
    username: 'Username',
    email: 'Email',
    phone: 'Phone',
    url: 'Url',
    domain: 'Domain',
    title: 'Title',

    recipient: {
      username: 'Username',
      email: 'Email',
      phone: 'Phone'
    }
  }
}
